import React from 'react';
import styled from 'styled-components';

import { Shield2, ArrowLeft } from '@crehana/icons';

import { Crehana } from '@crehana/icons/logos';

import { useTranslation } from '@crehana/i18n';

const WrapperHeader = styled.div`
  &:before,
  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0;
    background-color: ${props => props.theme.colors.primary.main};
    height: 100%;
    width: 200%;
    z-index: -1;
  }
  &:before {
    left: 0;
    transform: translateX(-99%);
  }
  &:after {
    right: 0;
    transform: translateX(99%);
  }
`;
const Header: React.FC<{ onClick?: () => void }> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <WrapperHeader className="relative py-16 border-b border-solid border-gray-light z-2 bg-primary-main px-16">
      <div className="flex items-center justify-between ml-auto mr-auto">
        <button type="button" onClick={onClick}>
          <ArrowLeft
            size={24}
            ignoreColor
            className="text-white fill-current"
          />
        </button>
        <Crehana size={16} ignoreColor className="text-white fill-current " />
        <p className="flex items-center">
          <Shield2 size={20} className="text-white fill-current" ignoreColor />
          <span className="hidden ml-8 text-white font-link md:inline-block">
            {t('SAFE_LABEL')}
          </span>
        </p>
      </div>
    </WrapperHeader>
  );
};

export default Header;
